import { z } from 'zod'
import { type LatLng } from './locations/latLng'
import { type AccountStatusId } from './ids'

export const LocationPlaceIdSchema = z.string().meta({
  description:
    'An external address autocomplete identifier returned by search or location autocomplete, or an existing Terros location ID with a `TLoc.`, `FA.`, `LocNew.`, `Can.`, or `PR.` prefix. Legacy `Loc:` values pass schema validation, but the current location reader does not resolve them and returns NotFound.',
})
export type LocationPlaceId = z.infer<typeof LocationPlaceIdSchema>

export type LocationAutocompleteResult = {
  placeId: LocationPlaceId
  text: string
  statusId?: AccountStatusId
}

type Viewport = {
  low: LatLng
  high: LatLng
}

type PlaceType =
  | 'administrative_area_level_1'
  | 'administrative_area_level_2'
  | 'administrative_area_level_3'
  | 'administrative_area_level_4'
  | 'administrative_area_level_5'
  | 'archipelago'
  | 'colloquial_area'
  | 'continent'
  | 'country'
  | 'establishment'
  | 'finance'
  | 'floor'
  | 'food'
  | 'general_contractor'
  | 'geocode'
  | 'health'
  | 'intersection'
  | 'locality'
  | 'natural_feature'
  | 'neighborhood'
  | 'place_of_worship'
  | 'plus_code'
  | 'point_of_interest'
  | 'political'
  | 'post_box'
  | 'postal_code'
  | 'postal_code_prefix'
  | 'postal_code_suffix'
  | 'postal_town'
  | 'premise'
  | 'room'
  | 'route'
  | 'street_address'
  | 'street_number'
  | 'sublocality'
  | 'sublocality_level_1'
  | 'sublocality_level_2'
  | 'sublocality_level_3'
  | 'sublocality_level_4'
  | 'sublocality_level_5'
  | 'subpremise'
  | 'town_square'

export type GoogleAddressComponent = {
  long_name: string
  short_name: string
  types: PlaceType[]
}

export type ModernGoogleAddressComponent = {
  longText: string
  shortText: string
  types: PlaceType[]
}

export type GooglePlaceDetail = {
  types: PlaceType[]
  formattedAddress: string
  addressComponents: ModernGoogleAddressComponent[]
  location: LatLng
  viewport: Viewport
  adrFormatAddress: string
  shortFormattedAddress: string
}

export type GoogleGeocodingGeometry = {
  location: {
    lat: number
    lng: number
  }
}
